export const VERSION = "18.6.0";
